import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { SortingMode, PagingPosition } from "ka-table/enums";
import stockService from "../services/stock-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import facilityService from "../services/facility-service";
import DatePicker from "react-datepicker";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
const tablePropsInit1 = {
  columns: [
    { key: "drg_name", title: "Drug" },
    { key: "drg_type", title: "Drug Type" },
    { key: "doc_name", title: "Doctor" },
    { key: "quantity", title: "Quantity" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const StocksReports = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showDrugList, setShowDrugList] = useState(false);
  const [facList, setFacList] = useState([]);
  const [selectedFac, setSelectedFac] = useState(0);
  const [reportDate, setReportDate] = useState();
  const [facName, setFacName] = useState("");
  const { register, handleSubmit, errors } = useForm({});
  const CustomCell2 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    let strngth = rowData.strength ? "-" + rowData.strength : "";
    let dosId = rowData.dos_id ? "-" + rowData.dos_id : "";
    return (
      <div>
        <span className="inline-block">
          {rowData.display_name
            ? rowData.display_name
            : rowData.drg_name + strngth + dosId}
        </span>
      </div>
    );
  };
  const CustomCell3 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block">
          {rowData.drg_type ? rowData.drg_type.replace(/_/g, " ") : ""}
        </span>
      </div>
    );
  };
  const [tableProps1, changeTableProps1] = useState(tablePropsInit1);
  const dispatch1 = async (action) => {
    changeTableProps1((prevState) => kaReducer(prevState, action));
  };
  const getExistFacs = async () => {
    try {
      setLoading(true);
      let resp = await facilityService.getFacilities();
      if (resp) {
        setFacList(resp);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const getReports = async (data) => {
    if (!reportDate) {
      const { hide } = cogoToast.error("Please choose valid date", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    } else {
      let repDate = moment(reportDate).format("YYYY-MM-DD");
      let params = {
        fac_id: data.stFacility,
        date: repDate,
      };
      try {
        setLoading(true);
        let resp = await stockService.getStockRep(params);
        if (resp.length > 0) {
          setLoading(false);
          setShowDrugList(true);
          setSelectedFac(data.stFacility);
          dispatch1(updateData(resp));
        } else {
          dispatch1(updateData([]));
          setShowDrugList(false);
          setLoading(false);
          const { hide } = cogoToast.error("No Records Found.", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        }
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving Stock Reports. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  };
  async function dwnloadReport() {
    const doc = new jsPDF("", "", "a3");
    doc.setFont("helvetica");
    doc.setFontSize(9);
    setLoading(true);
    let params = {
      fac_id: selectedFac,
      date: moment(reportDate).format("YYYY-MM-DD"),
    };
    let resp = await stockService.getStockRep(params);
    setLoading(false);
    let col = [
      "Drug",
      "Drug Type",
      "Doctor",
      "Quantity",
      "Facility",
      "Report Date",
    ];
    let rows = [];
    doc.setFontSize(12);
    doc.setFont("helvetica");
    doc.setFontSize(8);
    let top = 35;
    resp.forEach((ele, i) => {
      let strngth = ele.strength ? "-" + ele.strength : "";
      let dosId = ele.dos_id ? "-" + ele.dos_id : "";
      let temp = [
        ele.display_name ? ele.display_name : ele.drg_name + strngth + dosId,
        ele.drg_type !== 0 ? ele?.drg_type.replace(/_/g, " ") : "",
        ele?.doc_name,
        ele.quantity,
        facName,
        moment(reportDate).format("YYYY-MM-DD"),
      ];
      top = top + 5;
      rows.push(temp);
    });
    doc.autoTable(col, rows, { startY: 5 }, "left");
    doc.save("StockOrderReport.pdf");
  }
  useEffect(() => {
    getExistFacs();
  }, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">STOCK REPORTS</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(getReports)}>
            <ul className="">
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">Facility</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="stFacility"
                  id="stFacility"
                  aria-label="Select Facility"
                  ref={register({
                    required: "You must select facility",
                  })}
                  onChange={(event) => {
                    setFacName(
                      event.currentTarget.options[
                        event.currentTarget.selectedIndex
                      ].text
                    );
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                >
                  <option value="">Select Facility</option>
                  {facList
                    ? facList.map((facility, i) => {
                        return (
                          <option key={i} value={facility.id}>
                            {facility.name}
                          </option>
                        );
                      })
                    : null}
                </select>
                {errors.stFacility && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.stFacility?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3 stockDatepkr">
                <label className="text-labelclr font-semibold text-sm tracking-wider">Report Date</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <p>
                  <DatePicker
                    placeholderText="MM/DD/YYYY"
                    selected={reportDate}
                    onChange={(date) => {
                      setReportDate(date);
                    }}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  />
                </p>
              </li>
              <li className="inline-block text-sm leading-8 w-full">
                <button
                  type="submit"
                  className="text-white rounded  font-medium h-10 w-full bg-secondary bg-login_btn my-3 focus:outline-none"
                  aria-label="Create user"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
      <div
        className={`bg-white w-11/12 sm:w-2/4 mx-auto mt-2 mb-4 ${
          showDrugList ? "show" : "hidden"
        }`}
      >
        <div className="p-2 text-xs gridList overflow-x-auto">
        <Table
          {...tableProps1}
          childComponents={{
            cellText: {
              content: (props) => {
                // eslint-disable-next-line default-case
                switch (props.column.key) {
                  case "drg_name":
                    return <CustomCell2 {...props} />;
                  case "drg_type":
                    return <CustomCell3 {...props} />;
                }
              },
            },
          }}
          dispatch={dispatch1}
        />
        </div>
        <div className="bg-white w-full mb-2 inline-block">
          <input
            type="button"
            onClick={() => {
              dwnloadReport();
            }}
            value="Download"
            className="text-white w-full sm:w-auto h-8 px-6 
                bg-header_bg rounded text-xs font-medium capitalize 
                focus:outline-none float-right inline-block mr-4"
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(StocksReports)
);
